import { render, staticRenderFns } from "./ToC.vue?vue&type=template&id=3a936e20"
import script from "./ToC.vue?vue&type=script&lang=js"
export * from "./ToC.vue?vue&type=script&lang=js"
import style0 from "./ToC.vue?vue&type=style&index=0&id=3a936e20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports